import React from "react";
import Header from "../Header/Header";

export default function Navbar(props) {
  const { openTerminModal } = props;

  return (
    <div className="fixed-navbar active">
        <Header hclass={props.hclass} Logo={props.Logo} topbarNone={props.topbarNone} openTerminModal={openTerminModal} />
    </div>
  ); 
}